module.exports = __webpack_public_path__ + "724ac482cdf5d4870a1b9d64ce572057.svg";